export const addToWishlist = "/wishlist";
export const getWishlist = "/wishlist/get-my-wishlist";
export const deleteWishlist = "/wishlist";